/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosRequestConfig } from "axios";
// @ts-ignore

import enviroment from "../enviroments";

function createAxiosLoginInstance() {
  const config: AxiosRequestConfig = {
    baseURL: enviroment.BASE_URL, // ou outra URL se seu endpoint de login for diferente
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    // Se precisar de params fixos:
    params: {
      cc: "6909b8b9-7dfc-40e2-af74-3d0b25c65248",
    },
  };
  return axios.create(config);
}

const axiosServicesLogin = createAxiosLoginInstance();

// service.register({
//   async onResponseError(error: any) {
//     const originalRequest = error.config;

//     if (error.response.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         try {
//           const token = await new Promise((resolve, reject) => {
//             failedQueue.push({ resolve, reject });
//           });
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           return await axios(originalRequest);
//         } catch (err) {
//           return Promise.reject(err);
//         }
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       return new Promise((resolve, reject) => {
//         const toJson = localStorage.getItem("@token");
//         const datas = toJson == null ? null : JSON.parse(toJson);
//         axiosInstanceAuth
//           .get(
//             `identity/app-web/conta-usuario/v1/refresh-token?refreshToken=${datas.refreshToken}`
//           )
//           .then(({ data }) => {
//             const dataToRefres = {
//               token: data?.token?.access_token,
//               refreshToken: data?.token?.refresh_token,
//               expires_in: data?.token?.expires_in,
//               data_login: new Date(),
//             };

//             localStorage.setItem("@token", JSON.stringify(dataToRefres));

//             axios.defaults.headers.common.Authorization = `Bearer ${data?.token?.access_token}`;
//             originalRequest.headers.Authorization = `Bearer ${data?.token?.access_token}`;
//             processQueue(null, data?.token?.access_token);
//             resolve(axios(originalRequest));
//           })
//           .catch((err) => {
//             processQueue(err, null);
//             reject(err);
//           })
//           .finally(() => {
//             isRefreshing = false;
//           });
//       });
//     }
//     return Promise.reject(error);
//   },
// });

const requesSuccessHandler = (value: any) => {
  const toJson = localStorage.getItem("@token");
  const datas = toJson == null ? null : JSON.parse(toJson);

  if (datas?.token) {
    value.headers = { Authorization: `Bearer ${datas.token}` };
  }
  return value;
};

const requestErrorHandler = (error: any) => error;

axiosServicesLogin.interceptors.request.use(async (conf) => conf);

axiosServicesLogin.interceptors.request.use(
  requesSuccessHandler,
  requestErrorHandler
);
// let isRefreshing = false;
let failedQueue: any = [];

const processQueue = (error: any, token = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export default axiosServicesLogin;
